import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { VAT_TEXT_COMPONENT } from '../../../brands/default/content/components/deal';
import { getVatInfo } from '../../../helpers/deals';

const VatText = ({ deal }) => {
  if (!deal) return null;

  const entries = getVatInfo(deal);

  return (
    <>
      <p className="vattext-wrapper">
        <span>{VAT_TEXT_COMPONENT.vatText}</span>

        {entries.map((entry, index) => {
          const isPenultimate = index === entries.length - 2;
          const isLast = index === entries.length - 1;

          return (
            <Fragment key={index}>
              <span className="vattext-name">{entry.displayName}</span>
              {entry.vatNumber && (
                <span className="vattext-number">
                  {` ${VAT_TEXT_COMPONENT.vatNumber}${entry.vatNumber}`}
                </span>
              )}
              {!isPenultimate && !isLast && <span>, </span>}
              {isPenultimate && <span> and </span>}
            </Fragment>
          );
        })}
      </p>
      <style jsx>{`
        .vattext-wrapper {
          font-size: 12px;
          margin: 16px 0;
        }
        .vattext-number {
          font-weight: bold;
        }
      `}</style>
    </>
  );
};

VatText.propTypes = {
  deal: PropTypes.object,
};

VatText.defaultProps = {
  deal: null,
};

export default VatText;
